import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axios/axiosBaseQuery';

export const documentUploadBaseApi = createApi({
  reducerPath: `documentBaseApi`,
  baseQuery: axiosBaseQuery({ baseUrl: `/api/upload?path=` }),
  endpoints: () => ({}),
}).enhanceEndpoints({ addTagTypes: [`documents`, `Student`, `Remarks`] });
